/**
 * Lights Page - HAL 3000 - iPad Version
 * Interrupteurs GROS - Noms COMPLETS - Style DYMO authentique
 * OCCUPE TOUT L'ESPACE + 1 interrupteur LIBRE
 * Animation séquentielle avec son de clic
 */
import { useState, useEffect, useCallback, useRef } from 'react';
import Layout from '@/components/Layout';
import CockpitToggle from '@/components/CockpitToggle';
import { api } from '@/App';
import { RefreshCw, Power, PowerOff, Settings, X, Save, Plus, Trash2 } from 'lucide-react';

// Son de clic d'interrupteur (base64 encoded)
const CLICK_SOUND = 'data:audio/wav;base64,UklGRl4FAABXQVZFZm10IBAAAAABAAEARKwAAIhYAQACABAAZGF0YToFAACAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgH5+goKGhoqKjo6SkpqanqKipqqqrq6urrKytra2ura2traysrKurq6qqqampqKiop6enp6amp6empqWlpKSkpKOjo6KhoaGhoKCfn5+enZ2dnJycnJubm5qampqamZmZmZiYmJiYl5eXl5aWlpaWlZWVlZSUlJSUk5OTk5KSkpKSkZGRkZGQkJCQj4+Pj4+Ojo6OjY2NjY2MjIyMi4uLi4uKioqKiYmJiYiIiIiIh4eHh4aGhoaFhYWFhISEhIODg4OCgoKCgoGBgYGAgICAgH9/f39+fn5+fX19fXx8fHx7e3t7enp6enl5eXl4eHh4d3d3d3Z2dnZ1dXV1dHR0dHNzc3NycnJycXFxcXBwcHBvb29vbm5ubm1tbW1sbGxsa2tra2pqamppampqaWlpaWhoaGhnZ2dnZmZmZmVlZWVkZGRkY2NjY2JiYmJhYWFhYGBgYF9fX19eXl5eXV1dXVxcXFxbW1tbWlpaWllZWVlYWFhYV1dXV1ZWVlZVVVVVVFRUVFNTU1NSUlJSUVFRUVBQUFBPT09PTk5OTk1NTU1MTExMS0tLS0pKSkpJSUlJSEhISEdHR0dGRkZGRUVFRURERERDQ0NDQkJCQkFBQUFAQEBAP0A/QD9AP0A/QD9AP0A+QD5APkA+QD5APkA+QD5APkA+QD5APkA+QD1APUA9QD1APUA9QD1APUA9QD1APUA9QD1APUA9QD1APUA9QD1APUA9QD1APUA9QD1APUA9QD1APUA9QD1APUA9QD1APUA9QD1APUA9QD5APkA+QD5APkA+QD5APkA+QD5APkA+QD5APkA+QD9AP0A/QD9AP0A/QD9AQEBAQEFBQUFCQkJCQ0NDQ0RERERFRUVFRkZGRkdHR0dISEhISUlJSUpKSkpLS0tLTExMTE1NTU1OTk5OT09PT1BQUFBRUVFRUlJSUlNTU1NUVFRUVVVVVVZWVlZXV1dXWFhYWFlZWVlaWlpaW1tbW1xcXFxdXV1dXl5eXl9fX19gYGBgYWFhYWJiYmJjY2NjZGRkZGVlZWVmZmZmZ2dnZ2hoaGhpaWlpampqamtra2tsbGxsbW1tbW5ubm5vb29vcHBwcHFxcXFycnJyc3Nzc3R0dHR1dXV1dnZ2dnd3d3d4eHh4eXl5eXp6enp7e3t7fHx8fH19fX1+fn5+f39/f4CAgICBgYGBgoKCgoODg4OEhISEhYWFhYaGhoaHh4eHiIiIiImJiYmKioqKi4uLi4yMjIyNjY2Njo6Ojo+Pj4+QkJCQkZGRkZKSkpKTk5OTlJSUlJWVlZWWlpaWl5eXl5iYmJiZmZmZmpqampmamZqamZqZmpqampqbm5ubm5ycnJydnZ2dnp6enp+fn5+goKCgoaGhoaKioqKjo6OjpKSkpKWlpaWmpqamqKioqKmpqamqqqqqqqqrq6urrKysrK2tra2urq6ur6+vr7CwsLCwsLCwsbGxsbKysrKzs7OztLS0tLW1tbW2tra2t7e3t7i4uLi5ubm5urq6uru7u7u8vLy8vb29vb6+vr6/v7+/wMDAwMHBwcHCwsLCw8PDw8TExMTFxcXFxsbGxsfHx8fIyMjIycnJycrKysrLy8vLzMzMzM3Nzc3Ozs7Oz8/Pz9DQ0NDR0dHR0tLS0tPT09PU1NTU1dXV1dbW1tbX19fX2NjY2NnZ2dna2tra29vb29zc3Nzd3d3d3t7e3t/f39/g4ODg4eHh4eLi4uLj4+Pj5OTk5OXl5eXm5ubm5+fn5+jo6Ojp6enp6urq6uvr6+vs7Ozs7e3t7e7u7u7v7+/v8PDw8PHx8fHy8vLy8/Pz8/T09PT19fX19vb29vf39/f4+Pj4+fn5+fr6+vr7+/v7/Pz8/P39/f3+/v7+////';

// Fonction pour jouer le son de clic
const playClickSound = () => {
  try {
    const audio = new Audio(CLICK_SOUND);
    audio.volume = 0.3;
    audio.play().catch(() => {});
  } catch (e) {
    // Silently fail if audio not supported
  }
};

// Délai helper
const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

// Étiquette DYMO authentique - Style embossé réaliste
const DymoLabel = ({ text, large = false }) => (
  <div 
    className={`${large ? 'px-3 py-1.5' : 'px-2 py-1'} text-center w-full`}
    style={{
      background: '#000',
      borderRadius: '2px',
      border: '1px solid #222',
      boxShadow: 'inset 0 1px 3px rgba(0,0,0,0.8)'
    }}
  >
    <span
      style={{
        fontFamily: "'Arial Narrow', 'Helvetica Neue', Arial, sans-serif",
        fontWeight: '800',
        fontSize: large ? '14px' : '12px',
        color: '#fff',
        letterSpacing: '1.5px',
        textTransform: 'uppercase',
        textShadow: '1px 1px 0 #333, -1px -1px 0 #111, 0 0 8px rgba(255,255,255,0.3)'
      }}
    >
      {text}
    </span>
  </div>
);

// Panneau d'interrupteur avec nom COMPLET - ALIGNEMENT FORCÉ
const LightSwitchPanel = ({ light, toggling, onToggle, editMode, groups, onToggleGroup, isEmpty = false }) => {
  if (isEmpty) {
    return (
      <div 
        className="flex flex-col items-center p-2 rounded-lg h-full"
        style={{
          background: 'linear-gradient(180deg, #0a0a0a 0%, #050505 100%)',
          border: '3px solid #1a1a1a'
        }}
      >
        {/* Zone interrupteur - Hauteur fixe */}
        <div className="flex-1 flex items-center justify-center">
          <div className="opacity-30">
            <CockpitToggle
              isOn={false}
              label=""
              disabled={true}
              size="xlarge"
            />
          </div>
        </div>
        {/* Zone label - Hauteur fixe en bas */}
        <div className="w-full h-12 flex items-start">
          <DymoLabel text="LIBRE" />
        </div>
      </div>
    );
  }

  const isOn = light.isOn;
  const isOnline = light.online;
  
  // Nom complet sans troncature
  const fullName = light.name
    .replace(/Éclairage\s*/gi, '')
    .replace(/Eclairage\s*/gi, '')
    .replace(/Lampe\s*/gi, '')
    .toUpperCase();
  
  return (
    <div 
      className={`relative flex flex-col items-center p-1 rounded-lg h-full ${!isOnline ? 'opacity-30' : ''}`}
      style={{
        background: isOn 
          ? 'linear-gradient(180deg, #1a1508 0%, #0a0a04 100%)' 
          : 'linear-gradient(180deg, #0f0f0f 0%, #050505 100%)',
        border: `2px solid ${isOn ? '#fbbf24' : '#2a2a2a'}`,
        boxShadow: isOn ? '0 0 20px #fbbf2430, inset 0 0 20px #fbbf2410' : 'none'
      }}
    >
      {/* Boutons groupe en mode édition */}
      {editMode && isOnline && (
        <div className="absolute -top-1 -right-1 flex gap-0.5 z-10">
          {groups.filter(g => g.id !== 'all').map(g => (
            <button
              key={g.id}
              onClick={(e) => { e.preventDefault(); e.stopPropagation(); onToggleGroup(g.id, light.id); }}
              className={`w-5 h-5 rounded text-[9px] font-bold ${g.lightIds.includes(light.id) ? 'bg-cyan-500 text-white' : 'bg-gray-700 text-gray-400'}`}
              type="button"
            >
              {g.name.charAt(0)}
            </button>
          ))}
        </div>
      )}
      
      {/* Zone interrupteur - Hauteur flexible */}
      <div className="flex-1 flex items-center justify-center">
        <button
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            if (isOnline && toggling !== light.id) {
              onToggle(light.id);
            }
          }}
          disabled={!isOnline || toggling === light.id}
          type="button"
          className="focus:outline-none"
          data-testid={`light-switch-${light.id}`}
        >
          <CockpitToggle
            isOn={isOn}
            label=""
            disabled={!isOnline || toggling === light.id}
            size="xlarge"
          />
        </button>
      </div>
      
      {/* Zone label - Hauteur fixe en bas, aligné en haut */}
      <div className="w-full h-12 flex items-start">
        <DymoLabel text={fullName} />
      </div>
    </div>
  );
};

const LightsPage = () => {
  const [lights, setLights] = useState([]);
  const [loading, setLoading] = useState(true);
  const [refreshing, setRefreshing] = useState(false);
  const [toggling, setToggling] = useState(null);
  const [editMode, setEditMode] = useState(false);
  
  const [groups, setGroups] = useState(() => {
    try {
      const saved = localStorage.getItem('hal_light_groups');
      return saved ? JSON.parse(saved) : [
        { id: 'all', name: 'TOUT', lightIds: [] },
        { id: 'ext', name: 'EXTÉRIEUR', lightIds: [] },
        { id: 'guirl', name: 'GUIRLANDES', lightIds: [] }
      ];
    } catch {
      return [{ id: 'all', name: 'TOUT', lightIds: [] }];
    }
  });
  
  const [newGroupName, setNewGroupName] = useState('');
  const [showAddGroup, setShowAddGroup] = useState(false);

  useEffect(() => {
    localStorage.setItem('hal_light_groups', JSON.stringify(groups));
  }, [groups]);

  const loadLights = useCallback(async () => {
    try {
      const response = await api.get('/integrations/tuya/devices');
      if (response.data?.success) {
        const devices = response.data.devices || [];
        const lightCategories = ['cz', 'dj', 'dc', 'kg'];
        const excludeCategories = ['ywbj', 'pir', 'mcs', 'wsdcg', 'wk', 'qn', 'dlq', 'qccdz', 'tdq', 'wg2'];
        
        // ⚠️ IDs VERSAILLES - LISTE FIGÉE - NE PAS MODIFIER SANS AUTORISATION
        const VERSAILLES_LIGHT_IDS = [
          'bfac3aedb01c81dacdsdg4', // Guirlande jardin versailles
          '0220052668c63aacbce0',   // Cave
          '67038047dc4f22e5f208',   // Lampe triple séjour
          '67038047dc4f22e6004b',   // Lampadaire séjour
          '80022672c44f33bd9594',   // Lampe tempête séjour
          'bf1af2345e50d445e05mvp', // Lampe guéridon salon
        ];
        
        const lightDevices = devices
          .filter(d => {
            const cat = d.category || '';
            const name = (d.name || '').toLowerCase();
            const roomName = (d.room || '').toLowerCase();
            const deviceId = d.id || d.device_id;
            
            // EXCLURE par ID (Versailles)
            if (VERSAILLES_LIGHT_IDS.includes(deviceId)) return false;
            
            // EXCLURE par room (Versailles)
            if (roomName.includes('versailles')) return false;
            
            if (excludeCategories.includes(cat)) return false;
            if (name.includes('capteur') || name.includes('détect') || name.includes('fumée')) return false;
            if (name.includes('incendie') || name.includes('mouvement') || name.includes('chauffage')) return false;
            if (name.includes('chauffe-eau') || name.includes('vanne') || name.includes('radiateur')) return false;
            
            return lightCategories.includes(cat) ||
              name.includes('lampe') || name.includes('light') ||
              name.includes('lumi') || name.includes('guirlande') ||
              name.includes('plafond') || name.includes('éclairage') ||
              name.includes('eclairage') || name.includes('cave') ||
              name.includes('parking') || name.includes('miroir') ||
              name.includes('extension') || name.includes('séjour') ||
              name.includes('salon');
          })
          .map(d => {
            let isOn = false;
            if (d.status && Array.isArray(d.status)) {
              const switchStatus = d.status.find(s => 
                s.code === 'switch_led' || s.code === 'switch_1' || s.code === 'switch'
              );
              if (switchStatus) isOn = switchStatus.value === true;
            }
            
            return {
              id: d.id || d.device_id,
              name: d.name,
              online: d.online,
              isOn,
              category: d.category,
              source: 'tuya'
            };
          })
          .sort((a, b) => {
            if (a.online !== b.online) return b.online - a.online;
            return a.name.localeCompare(b.name);
          });
        
        // Uniquement Tuya/SmartLife
        setLights(lightDevices);
      }
    } catch (error) {
      console.error('Error loading lights:', error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadLights();
    const interval = setInterval(loadLights, 15000);
    return () => clearInterval(interval);
  }, [loadLights]);

  const handleRefresh = async () => {
    setRefreshing(true);
    await loadLights();
    setTimeout(() => setRefreshing(false), 500);
  };

  const toggleLight = async (deviceId) => {
    const light = lights.find(l => l.id === deviceId);
    if (!light || !light.online) return;
    
    // Jouer le son de clic
    playClickSound();
    
    setToggling(deviceId);
    const newState = !light.isOn;
    
    try {
      await api.post(`/integrations/tuya/devices/${deviceId}/commands`, {
        commands: [{ code: 'switch_led', value: newState }]
      });
    } catch {
      try {
        await api.post(`/integrations/tuya/devices/${deviceId}/commands`, {
          commands: [{ code: 'switch_1', value: newState }]
        });
      } catch (e2) {
        console.error('Error toggling light:', e2);
      }
    }
    
    setLights(prev => prev.map(l => 
      l.id === deviceId ? { ...l, isOn: newState } : l
    ));
    
    setToggling(null);
  };

  // Animation séquentielle TOUT ON/OFF avec 0.5s entre chaque lampe
  const toggleAll = async (turnOn) => {
    setToggling('all');
    const onlineLights = lights.filter(l => l.online);
    
    // Allumage/extinction séquentiel avec animation
    for (let i = 0; i < onlineLights.length; i++) {
      const light = onlineLights[i];
      
      // Jouer le son de clic
      playClickSound();
      
      // Mettre à jour l'état visuel immédiatement
      setLights(prev => prev.map(l => 
        l.id === light.id ? { ...l, isOn: turnOn } : l
      ));
      
      // Envoyer la commande à l'API (sans attendre)
      api.post(`/integrations/tuya/devices/${light.id}/commands`, {
        commands: [{ code: 'switch_led', value: turnOn }]
      }).catch(() => {
        api.post(`/integrations/tuya/devices/${light.id}/commands`, {
          commands: [{ code: 'switch_1', value: turnOn }]
        }).catch(() => {});
      });
      
      // Attendre 0.5 seconde avant la prochaine lampe
      if (i < onlineLights.length - 1) {
        await delay(500);
      }
    }
    
    setToggling(null);
  };

  const toggleGroup = async (groupId, turnOn) => {
    const group = groups.find(g => g.id === groupId);
    if (!group) return;
    
    setToggling(`group-${groupId}`);
    
    const targetLights = groupId === 'all' 
      ? lights.filter(l => l.online)
      : lights.filter(l => l.online && group.lightIds.includes(l.id));
    
    for (const light of targetLights) {
      try {
        await api.post(`/integrations/tuya/devices/${light.id}/commands`, {
          commands: [{ code: 'switch_led', value: turnOn }]
        });
      } catch {}
    }
    
    setLights(prev => prev.map(l => {
      if (groupId === 'all' && l.online) return { ...l, isOn: turnOn };
      if (l.online && group.lightIds.includes(l.id)) return { ...l, isOn: turnOn };
      return l;
    }));
    
    setToggling(null);
  };

  const addGroup = () => {
    if (newGroupName.trim()) {
      const id = `group-${Date.now()}`;
      setGroups(prev => [...prev, { id, name: newGroupName.trim().toUpperCase(), lightIds: [] }]);
      setNewGroupName('');
      setShowAddGroup(false);
    }
  };

  const deleteGroup = (groupId) => {
    if (groupId === 'all') return;
    setGroups(prev => prev.filter(g => g.id !== groupId));
  };

  const toggleLightInGroup = (groupId, lightId) => {
    setGroups(prev => prev.map(g => {
      if (g.id !== groupId) return g;
      const lightIds = g.lightIds.includes(lightId)
        ? g.lightIds.filter(id => id !== lightId)
        : [...g.lightIds, lightId];
      return { ...g, lightIds };
    }));
  };

  const onlineLights = lights.filter(l => l.online);
  const lightsOn = lights.filter(l => l.online && l.isOn);

  const getGroupStats = (group) => {
    if (group.id === 'all') {
      return { on: lightsOn.length, total: onlineLights.length };
    }
    const groupLights = lights.filter(l => group.lightIds.includes(l.id));
    const groupOn = groupLights.filter(l => l.isOn);
    return { on: groupOn.length, total: groupLights.length };
  };

  // Calculer grille adaptative : 6 colonnes max, lignes selon le nombre d'appareils
  // Pas de slots vides sauf 1 LIBRE si on a de la place
  const COLS = 6;
  const totalItems = lights.length;
  const rows = Math.max(2, Math.ceil(totalItems / COLS));
  const totalSlots = rows * COLS;
  // Ajouter des slots LIBRE seulement pour compléter la dernière ligne
  const emptySlots = totalSlots - totalItems;

  return (
    <Layout title="Éclairage">
      <div className="h-full flex flex-col overflow-hidden" style={{ background: '#000' }}>
        
        {/* HEADER */}
        <div 
          className="flex items-center justify-between px-4 py-2 flex-shrink-0"
          style={{ background: '#0a0a0a', borderBottom: '2px solid #333' }}
        >
          <div className="flex items-center gap-4">
            <DymoLabel text="ÉCLAIRAGES" large />
            
            {/* Indicateur status */}
            <div className="flex items-center gap-2">
              <div 
                className="w-4 h-4 rounded-full"
                style={{ 
                  background: lightsOn.length > 0 ? '#fbbf24' : '#333', 
                  boxShadow: lightsOn.length > 0 ? '0 0 15px #fbbf24' : 'none' 
                }}
              />
              <span className="text-lg font-mono text-amber-300 font-bold">
                {lightsOn.length} ON / {onlineLights.length}
              </span>
            </div>
          </div>

          <div className="flex items-center gap-2">
            <button
              onClick={() => setEditMode(!editMode)}
              className={`flex items-center gap-1.5 px-3 py-1.5 rounded font-mono text-sm transition-all ${editMode ? 'bg-cyan-600 text-white' : 'bg-gray-800 text-gray-400 hover:bg-gray-700'}`}
            >
              <Settings className="w-4 h-4" />
              {editMode ? 'OK' : 'EDIT'}
            </button>
            
            <button 
              onClick={() => toggleAll(true)} 
              disabled={toggling === 'all'} 
              data-testid="all-on-btn"
              className="flex items-center gap-1.5 px-4 py-2 rounded font-mono text-sm font-bold disabled:opacity-50"
              style={{ background: '#4a3f2f', border: '2px solid #fbbf24', color: '#fbbf24' }}
            >
              <Power className="w-5 h-5" /> TOUT ON
            </button>
            <button 
              onClick={() => toggleAll(false)} 
              disabled={toggling === 'all'} 
              data-testid="all-off-btn"
              className="flex items-center gap-1.5 px-4 py-2 rounded font-mono text-sm font-bold disabled:opacity-50"
              style={{ background: '#1a1a1a', border: '2px solid #444', color: '#888' }}
            >
              <PowerOff className="w-5 h-5" /> TOUT OFF
            </button>
            <button 
              onClick={handleRefresh} 
              disabled={refreshing} 
              data-testid="refresh-lights"
              className="p-2 rounded"
              style={{ background: '#0a2030', border: '2px solid #1a4060' }}
            >
              <RefreshCw className={`w-5 h-5 text-cyan-400 ${refreshing ? 'animate-spin' : ''}`} />
            </button>
          </div>
        </div>

        {/* BARRE DE GROUPES */}
        <div 
          className="flex items-center gap-2 px-4 py-1.5 flex-shrink-0 overflow-x-auto"
          style={{ background: '#050505', borderBottom: '1px solid #222' }}
        >
          {groups.map(group => {
            const stats = getGroupStats(group);
            const isActive = stats.on > 0;
            
            return (
              <div key={group.id} className="flex items-center gap-1 flex-shrink-0">
                {editMode && group.id !== 'all' && (
                  <button onClick={() => deleteGroup(group.id)} className="p-1 text-red-400 hover:bg-red-900/30 rounded">
                    <Trash2 className="w-4 h-4" />
                  </button>
                )}
                <div 
                  className="flex items-center gap-2 px-3 py-1 rounded font-mono text-sm font-bold"
                  style={{ 
                    background: isActive ? '#4a3f2f' : '#111',
                    border: `2px solid ${isActive ? '#fbbf24' : '#333'}`,
                    color: isActive ? '#fbbf24' : '#555'
                  }}
                >
                  <span>{group.name}</span>
                  <span>({stats.on}/{stats.total})</span>
                </div>
                <button 
                  onClick={() => toggleGroup(group.id, true)} 
                  disabled={toggling === `group-${group.id}`} 
                  className="p-1.5 rounded bg-amber-900/30 text-amber-400 hover:bg-amber-900/50 disabled:opacity-50"
                >
                  <Power className="w-4 h-4" />
                </button>
                <button 
                  onClick={() => toggleGroup(group.id, false)} 
                  disabled={toggling === `group-${group.id}`} 
                  className="p-1.5 rounded bg-gray-800 text-gray-400 hover:bg-gray-700 disabled:opacity-50"
                >
                  <PowerOff className="w-4 h-4" />
                </button>
              </div>
            );
          })}
          
          {editMode && (
            showAddGroup ? (
              <div className="flex items-center gap-1 flex-shrink-0">
                <input 
                  type="text" 
                  value={newGroupName} 
                  onChange={(e) => setNewGroupName(e.target.value)} 
                  placeholder="Nom" 
                  className="px-2 py-1 rounded bg-gray-800 border border-gray-600 text-white text-sm w-24"
                  onKeyPress={(e) => e.key === 'Enter' && addGroup()}
                />
                <button onClick={addGroup} className="p-1.5 bg-green-600 rounded text-white"><Save className="w-4 h-4" /></button>
                <button onClick={() => setShowAddGroup(false)} className="p-1.5 bg-gray-600 rounded text-white"><X className="w-4 h-4" /></button>
              </div>
            ) : (
              <button onClick={() => setShowAddGroup(true)} className="flex items-center gap-1 px-3 py-1 rounded bg-cyan-900/30 text-cyan-400 text-sm font-mono hover:bg-cyan-900/50">
                <Plus className="w-4 h-4" /> GROUPE
              </button>
            )
          )}
        </div>

        {/* GRILLE D'INTERRUPTEURS - Adaptative */}
        <div className="flex-1 p-3 overflow-hidden">
          {loading ? (
            <div className="h-full flex items-center justify-center">
              <div className="text-amber-200/50 font-mono text-2xl animate-pulse">CHARGEMENT...</div>
            </div>
          ) : lights.length === 0 ? (
            <div className="h-full flex items-center justify-center">
              <div className="text-amber-200/50 font-mono text-xl">AUCUN ÉCLAIRAGE DÉTECTÉ</div>
            </div>
          ) : (
            <div 
              className="h-full grid gap-1.5"
              style={{ 
                gridTemplateColumns: `repeat(${COLS}, 1fr)`,
                gridTemplateRows: `repeat(${rows}, 1fr)`
              }}
            >
              {lights.map(light => (
                <LightSwitchPanel
                  key={light.id}
                  light={light}
                  toggling={toggling}
                  onToggle={toggleLight}
                  editMode={editMode}
                  groups={groups}
                  onToggleGroup={toggleLightInGroup}
                />
              ))}
              {/* Emplacements LIBRE pour compléter la ligne */}
              {Array.from({ length: emptySlots }).map((_, i) => (
                <LightSwitchPanel key={`empty-${i}`} isEmpty />
              ))}
            </div>
          )}
        </div>

        {/* FOOTER */}
        <div 
          className="flex items-center justify-end px-4 py-1 flex-shrink-0"
          style={{ background: '#050505', borderTop: '1px solid #222' }}
        >
          <span className="text-gray-600 font-mono text-xs">HAL 3000</span>
        </div>
      </div>
    </Layout>
  );
};

export default LightsPage;
